import { render, staticRenderFns } from "./OtsTableGroupNew.vue?vue&type=template&id=13909f98&"
import script from "./OtsTableGroupNew.vue?vue&type=script&lang=js&"
export * from "./OtsTableGroupNew.vue?vue&type=script&lang=js&"
import style0 from "./OtsTableGroupNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports